import {
  ShoppingOutlined,
  MoneyCollectOutlined,
  RocketOutlined,
} from "@ant-design/icons";

export const tabOptions = [
  {
    key: "launchpad",
    label: "LaunchPad",
    Icon: RocketOutlined,
  },
  {
    key: "buy",
    label: "Buy",
    Icon: ShoppingOutlined,
  },
  {
    key: "withdraw",
    label: "Withdraw",
    Icon: MoneyCollectOutlined,
  },
];
